export default __webpack_public_path__ + "static/21-325d398aca14734eb2d755f8b7680a58.png";